export enum TagTypes {
  None = '',
  Active = 'active',
  Greyed = 'greyed',
  DarkGreyed = 'dark-greyed',
  Warn = 'warn',
  Orange = 'orange',
  LightBlue = 'light-blue'
}
